<template>
  <div
    class="custom-ui-search-box-wrapper"
    :style="{ width: expanded ? '100%' : 'auto' }"
    v-click-outside="close"
  >
    <div class="custom-ui-search-box">
      <input
        :style="{ width: expanded ? '100%' : 'auto' }"
        type="text"
        v-model="model"
        @keypress.enter="submit"
        :placeholder="placeholder"
        :aria-label="placeholder || 'Search'"
        :disabled="disabled"
        name="ui-search-box"
      />
      <button type="button" @click="submit" :disabled="disabled">
        <i class="fa-solid fa-search" v-if="!loading" />
        <i class="fa-solid fa-spinner" v-else />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IUISearchBox } from '@/types/Components/UIKit'
  import { ref } from 'vue'

  const {
    loading = false,
    placeholder = '',
    disabled = false,
    expanded = false,
  } = defineProps<IUISearchBox>()

  const model = defineModel<string>({ required: true })
  const display = ref<boolean>(false)

  const emit = defineEmits(['type'])

  const close = () => {
    display.value = false
  }

  const submit = () => {
    emit('type', model.value)
  }
</script>

<style lang="scss" scoped>
  .custom-ui-search-box-wrapper {
    position: relative;
    .custom-ui-search-box {
      display: flex;
      align-items: center;
      height: 2rem;
      input {
        border: 1px solid $border-color;
        border-radius: 5px 0 0 5px;
        outline: none;
        height: 100%;
        padding: 0 0.5rem;
      }
      button {
        background-color: $brandColor;
        color: $white;
        border: 1px solid $brandColor;
        border-radius: 0 5px 5px 0;
        font-size: 14px;
        cursor: pointer;
        height: 100%;
        width: 2rem;
      }
    }
    .custom-ui-search-box-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 200px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      z-index: 999;
      overflow-y: auto;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @include scroll-bar;
      .dropdown-item {
        padding: 0.5rem;
        color: $primary-text-color;
        cursor: pointer;
        transition: 0.2s ease;
        font-size: 0.825rem;
        &:hover {
          background-color: $brandColor;
          color: $white;
        }
      }
    }
  }
</style>
